import { render, staticRenderFns } from "./FormularioResultado.vue?vue&type=template&id=be0450ce&scoped=true"
import script from "./FormularioResultado.vue?vue&type=script&lang=js"
export * from "./FormularioResultado.vue?vue&type=script&lang=js"
import style0 from "./FormularioResultado.vue?vue&type=style&index=0&id=be0450ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0450ce",
  null
  
)

export default component.exports